export const resolveTestedAt = (testResult, draft) => (
  testResult?.tested_at || draft?.tested_at || null
);
